import { JSXElementConstructor, ReactElement } from 'react';

export { FilterBar } from './FilterBar';
export { BarFilter } from './components/BarFilter';

export interface IFilterBarProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children?: ReactElement<IBarFilterProps, string | JSXElementConstructor<any>> | ReactElement<IBarFilterProps, string>[];
    onChange: (filters: ICurrentFilter[]) => void;
    onFilterTypeAdd: (filter: ICurrentFilter) => Promise<IData[]>;
    value?: ICurrentFilter[];
    disabled?: boolean;
    showSearch?: boolean;
}

export interface IData {
    caption: string;
    value: string;
}

export interface IFilterBarContext {
    doesItemHaveValue: (name: string) => boolean;
    filterTypes: IAvailableFilter[];
    hasFilters: boolean;
    onFilterTypeAdd: (filter: IAvailableFilter) => Promise<IData[]>;
}

export interface IBarFilterProps {
    name: string;
    type: 'SingleSelect' | 'MultipleSelect';
}

export interface ICurrentFilter {
    name: string;
    value?: IData[];
}

export interface ISelectedFilters {
    [key: string]: IData | IData[];
}

export interface IAvailableFilter {
    multiple: boolean;
    name: string;
    showOptions?: boolean;
    value?: IData[];
}

export interface IFilterBarRef {
    clearFilters: () => void;
    setFilters: (data: IAvailableFilter[]) => void;
    setInitialFilters: (filters: ICurrentFilter[]) => void;
}
